import {useState,useEffect,useRef} from 'react'; 
import  Bredcrum  from '../../components/bredcrum';
import { Tag } from 'primereact/tag';
import {Tablescom} from '../../components/tablescomp';
import { Toast } from 'primereact/toast';

import {userservices} from '../../services/userServices';
import {productservices} from '../../services/productServices';
import {Titlebar,Searchbox,Label} from  '../../components/fieldsComp';
import {useNavigate} from 'react-router';
const Ingredientadd = () =>{

        const [users,setUsers] = useState([]);
        const [userloaded,setUserloaded] = useState(true);
        const toast = useRef(null);
        const navigate = useNavigate();

        useEffect(()=>{
            // getusers();
        },[]); 

        const [formData, setFormData] = useState({
            // product_name: '',
            // sku_code: '',
            // stock_on_hand: '',
            // stock_needed: '',
            // discrepancy_alert: '', // boolean: can be true/false or 'true'/'false'
            // restock_alert_threshold: '',
            // stock_location: '',
            // stock_type: '', // 'finished' or 'component'
        });
        

        const handleChange = (e) => {
            setFormData({
            ...formData,
            [e.target.name]: e.target.value,
            });
        };

        const handleSave = () => {
            // console.log('Form Data:', formData);
            // return;
            // Add your save logic here
            productservices.createingredient(formData).then((response)=>{
                console.log(response);
                 if(response.status == 200){
                    //  console.log€0
                    toast.current.show({ severity: 'success', summary: 'Product', detail: 'Product added successfully' }); 
                    navigate(-1);
                 }else{
                    toast.current.show({ severity: 'error', summary: 'Product', detail: `${response.data.data}` }); 
                 }   
            }).catch((error)=>{
                toast.current.show({ severity: 'error', summary: 'Product', detail: 'Error' }); 
            });
        };

        const handleClose = () => {
            // Reset form or close modal logic
            console.log('Form Closed');
        };
    


//   const getusers  = ()=> {
//         setUserloaded(false);
//         userservices.getusers().then((response)=>{
//             if(response.status == 200){
//               console.log(response.data.data);
//                 setUsers(response.data.data);
//                 setUserloaded(true);
//             }else{
//                 setUsers([]);
//                 setUserloaded(true);
//             }  
//         }).catch((error)=>{
//             setUsers([]);
//             setUserloaded(true);
//         }); 
//   } 
  
  return(
       <>
          <Toast ref={toast} /> 
          <Bredcrum title={'Product/addproduct'} divider={false}/>
          <div class="row">
              {/* <div className='col-md-12 mb-4 mt-4'>
                 <div className='flex-box flex-between'>
                      <button className='btn btn-primary rounded-pill custom-btn-color custom-btn-br-color custom-btn-style'>Add New Product</button> 
                      <Searchbox/>
                  </div> 
              </div>  */}
             
              
              <Titlebar text={'Add Free-Issued Ingredients'}/>
              <div className="col-md-12 mt-3">
                  <div className='card ps-5 pe-5'>
                    <div className='card-body card-body-style'>
                         
                         <div className='row'>
                         <div className="container mt-4">
                         <form>
                                <div className="row">
                                    <div className="col-md-6 form-group">
                                    <Label name="Ingredient Name" />
                                    <input
                                        type="text"
                                        name="ingredient_name"
                                        className="form-control"
                                        placeholder="Enter Ingredient Name"
                                        value={formData.ingredient_name}
                                        onChange={handleChange}
                                    />
                                    </div>

                                    <div className="col-md-6 form-group">
                                    <Label name="SKU Code" />
                                    <input
                                        type="text"
                                        name="sku_code"
                                        className="form-control"
                                        placeholder="Enter Master SKU Code"
                                        value={formData.sku_code}
                                        onChange={handleChange}
                                    />
                                    </div>

                                    <div className="col-md-6 form-group">
                                    <Label name="Supplier" />
                                    <input
                                        type="text"
                                        name="supplier"
                                        className="form-control"
                                        placeholder="supplier"
                                        value={formData.supplier}
                                        onChange={handleChange}
                                    />
                                    </div>

                                    <div className="col-md-6 form-group">
                                    <Label name="Cost per Unit" />
                                    <input
                                        type="number"
                                        name="stock_needed"
                                        className="form-control"
                                        placeholder="Enter Stock Needed"
                                        value={formData.stock_needed}
                                        onChange={handleChange}
                                    />
                                    </div>

                                    <div className="col-md-6 form-group">
                                    <Label name="Units Used per Product" />
                                     <input
                                        type="number"
                                        name="units_used_per_product"
                                        className="form-control"
                                        placeholder="Enter Units Used per Product"
                                        value={formData.units_used_per_product}
                                        onChange={handleChange}
                                    />
                                    </div>

                                    <div className="col-md-6 form-group">
                                    <Label name="Total Stock Used Across Products" />
                                    <input
                                        type="number"
                                        name="total_stock_used_across_products"
                                        className="form-control"
                                        placeholder="Enter Restock Alert Threshold"
                                        value={formData.total_stock_used_across_products}
                                        onChange={handleChange}
                                    />
                                    </div>

                                    <div className="col-md-6 form-group">
                                    <Label name="Stock Level" />
                                    <input
                                        type="text"
                                        name="stock_level"
                                        className="form-control"
                                        placeholder="Enter Stock Level"
                                        value={formData.stock_level}
                                        onChange={handleChange}
                                    />
                                    </div>

                                    <div className="col-md-6 form-group">
                                    <Label name="Restock Alert" />
                                    <input
                                        type="text"
                                        name="stock_alert"
                                        className="form-control"
                                        placeholder="Enter Stock Alert"
                                        value={formData.stock_alert}
                                        onChange={handleChange}
                                    />
                                    </div>
                                </div>

                                <br></br>
                                <br></br>
                                <div className="row">
                                    <div className='col-md-6'>
                                    <button
                                    type="button"
                                    className="btn color-white me-2 w-100 rounded custom-btn-br-color custom-btn-color"
                                    onClick={handleSave}
                                    >
                                    Save
                                    </button>
                                    </div>

                                    <div className='col-md-6'>
                                    <button
                                    type="button"
                                    className="btn color-white w-100 rounded custom-btn-color-secondary"
                                    onClick={handleClose}
                                    >
                                    Close
                                    </button>
                                    </div>
                                </div>
                                </form>

                                </div>

                         </div>
                     </div>
                 </div>
              </div>   
          </div>
       </>
    );   
 }
 export default Ingredientadd;